<template>
    <div>
        <div v-if="picture">
            <div class="flex justify-center">
                <div class="inline-block">
                    {{ title }}
                </div>
            </div>
            <div class="flex justify-center">
                <slot name="picture">
                    <img src="/img/utils/undraw_blank_canvas_empty_state.png" alt="empty state" />
                </slot>
            </div>
        </div>
        <div v-else class="text-center">
            <slot v-if="withIcon" name="icon">
                <svg
                    class="mx-auto h-12 w-12 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                >
                    <path
                        vector-effect="non-scaling-stroke"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                    />
                </svg>
            </slot>
            <h3 class="mt-2 text-sm font-medium text-gray-900">{{ title }}</h3>
            <p class="mt-1 text-sm text-gray-500">
                {{ subtitle }}
            </p>
            <slot v-if="withButton" name="button"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmptyState',
    props: {
        picture: {
            type: Boolean,
            default: false,
        },
        withIcon: {
            type: Boolean,
            default: false,
        },
        withButton: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
    },
};
</script>
